import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaResumenId: 0,
    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    fechaCierre: '1900-01-01',
    fechaVencimiento: '1900-01-01',
    totalPlasticosPesos: 0,
    importePesos: 0,
    importeDolares: 0,
    importePagadoPesos: 0,
    importePagadoDolares: 0,
    saldoPesos: 0,
    saldoDolares: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, tarjetaResumenId) {
        state.tarjetaResumenId = tarjetaResumenId;
        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';
        state.fechaCierre = '1900-01-01';
        state.fechaVencimiento = '1900-01-01';
        state.importePesos = 0;
        state.importeDolares = 0;
        state.importePagadoPesos = 0;
        state.importePagadoDolares = 0;
        state.saldoPesos = 0;
        state.saldoDolares = 0;
    },
    'SET_TARJETA_RESUMEN_CIERRE' (state, tarjetaResumenCierre) {
        state.banco = tarjetaResumenCierre.banco;
        state.tarjetaMarca = tarjetaResumenCierre.tarjetaMarca;
        state.numeroCuenta = tarjetaResumenCierre.numeroCuenta;
        state.fechaCierre = moment(tarjetaResumenCierre.fechaCierre).format('YYYY-MM-DD');
        state.fechaVencimiento = moment(tarjetaResumenCierre.fechaVencimiento).format('YYYY-MM-DD');
        state.importePesos = tarjetaResumenCierre.importePesos;
        state.importeDolares = tarjetaResumenCierre.importeDolares;
        state.importePagadoPesos = tarjetaResumenCierre.importePagadoPesos;
        state.importePagadoDolares = tarjetaResumenCierre.importePagadoDolares;
        state.saldoPesos = tarjetaResumenCierre.importePesos - tarjetaResumenCierre.importePagadoPesos;
        state.saldoDolares = tarjetaResumenCierre.importeDolares - tarjetaResumenCierre.importePagadoDolares;
    },    
};

const actions = {
    inicializar ( { commit }, tarjetaResumenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', tarjetaResumenId);

            apiAxios.get(`tarjetasresumenes/${tarjetaResumenId}/cierre`)
                .then(res => {
                    commit('SET_TARJETA_RESUMEN_CIERRE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let tarjetaResumenSaldos = {
                saldoPendientePesos: state.saldoPesos,
                saldoPendienteDolares: state.saldoDolares,
            };

            apiAxios.post(`tarjetasresumenes/${state.tarjetaResumenId}/cierre/saldos`, tarjetaResumenSaldos)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}